import { LinkIcon, AudienceIcon, RetentionIcon } from '@/shared/assets'
import { NavbarItem } from '../NavbarItem/NavbarItem'
import './navbarAnalytics.scss'
import {
    useActiveWorkspace,
    workspacePath,
} from '@/true-fsd/data/advertiser-account'

export const NavbarAnalytics = () => {
    // const hostname = window.location.hostname

    // Hide the retention item if the hostname is app.synapex.ai
    // const showRetention = hostname !== 'app.synapex.ai'
    const showRetention = false
    const { activeWorkspace, permission } = useActiveWorkspace()

    const showAudience = activeWorkspace.workspace_type === 'channel'

    return (
        <div className="navbar-analytics">
            <NavbarItem
                to={workspacePath(activeWorkspace, 'analytics/links')}
                text="Ссылки"
                isOpen={true}
                icon={LinkIcon}
                classNameText="navbar-analytics__links"
            />
            {showRetention && (
                <NavbarItem
                    to={workspacePath(activeWorkspace, 'analytics/retention')}
                    text="Удержание"
                    isOpen={true}
                    icon={RetentionIcon}
                    disabled={!permission.retention}
                />
            )}
            {showAudience && (
                <NavbarItem
                    to={workspacePath(activeWorkspace, 'analytics/audience')}
                    text="Аудитория"
                    isOpen={true}
                    icon={AudienceIcon}
                    disabled={!permission.audience}
                />
            )}
        </div>
    )
}
